import pinselwaschtische from './pinselwaschtische.jpg';

export const teilreinigerImages = {
    pinselwaschtische,
};
